import { Injectable } from '@angular/core';
import { firstValueFrom, forkJoin, startWith } from 'rxjs';
import { EmployeeObjectiveStatistics } from '../models/EmployeeObjectiveStatistics';
import { ObjectiveStatus } from '../models/Objective';
import { ObjectiveCategory } from '../models/ObjectiveCategory';
import { ObjectiveRights } from '../models/ObjectiveRights';
import { IObjectiveSettings } from '../models/ObjectiveSettings';
import { ObjectiveType } from '../models/ObjectiveType';
import { ObjectiveService } from './objective-service';

@Injectable({
  providedIn: 'root'
})
export class EmployeePerformanceObjectivesSingletonService {

  public settings: IObjectiveSettings;
  public statusses: ObjectiveStatus[] = [];
  public types: ObjectiveType[] = [];
  public categories: ObjectiveCategory[] = [];
  public rights: ObjectiveRights;

  public statisticsMap: Map<number, EmployeeObjectiveStatistics> = new Map();

  constructor(private objectiveService: ObjectiveService) { }

  public async getDependencies(currentStudentId: number) {
    let settings$ = this.objectiveService.getAllSettings(currentStudentId, true);
    let categories$ = this.objectiveService.getCategories(true).pipe(startWith(null));
    let statusses$ = this.objectiveService.getStatusses(true).pipe(startWith(null));
    let types$ = this.objectiveService.getTypes(true).pipe(startWith(null));
    let rights$ = this.objectiveService.getObjectiveRights(currentStudentId);

    const { settings, categories, statusses, types, rights } = await firstValueFrom(
      forkJoin(
        {
          settings: settings$,
          categories: categories$,
          statusses: statusses$,
          types: types$,
          rights: rights$
        }
      )
    )

    this.settings = settings;
    this.categories = categories;
    this.statusses = statusses.filter(t => t.isUsed);
    this.types = types;
    this.rights = rights;
  }
}
